/**
 * Employee Web — `/me/assets` landing route.
 *
 * Phase 18 Plan 02. Shows the caller's actively allocated equipment with
 * thumbnails of the issue condition photos (clickable into a lightbox).
 * Permission gate: `asset:read:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeAssetsLanding } from "../features/assets/MeAssetsLanding";

export const Route = createFileRoute("/_auth/me/assets")({
  staticData: { breadcrumb: { labelKey: "assets:me.assets.page.title" } },
  beforeLoad: requirePermission({
    anyOf: ["asset:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeAssetsRoute,
});

function MeAssetsRoute(): JSX.Element {
  return <MeAssetsLanding />;
}
